import React, {useState, useContext} from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SearchIcon from '@material-ui/icons/Search'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import FilterListIcon from '@material-ui/icons/FilterList'
import {Typography} from '@material-ui/core'
import PopGroupPicker from './PopGroupPicker'
import {ReservationContext} from '../../../context/Reservation'
import './GroupSelect.scss'

const GroupSelect = ({options, value, loading = false, onChange}) => {
  const [elRef, setElRef] = useState(null)

  const {reservation} = useContext(ReservationContext)

  const handleClick = e => {
    if (!reservation.is_edit === true) {
      setElRef(e.target)
    }
  }

  const handleClose = e => {
    setElRef(null)
  }

  const handleClickOption = (e, o) => {
    if (onChange) {
      onChange(e, o)
    }
  }

  return (
    <>
      <div
        onClick={handleClick}
        className={
          reservation.is_edit === true
            ? 'c-search-reserve-item__group-select reserved-for-disabled'
            : 'c-search-reserve-item__group-select curser-pointer-reserved-for'
        }
      >
        <Typography style={{flex: 1}} className="ap-typography ap-typography--sm">
          {value?.name || '--'}
        </Typography>
        <div>
          <ExpandMoreIcon />
        </div>
      </div>

      <PopGroupPicker
        open={!!elRef}
        anchorEl={elRef}
        onClose={handleClose}
        options={options}
        value={value}
        loading={loading}
        onClickOption={handleClickOption}
      />
    </>
  )
}

export default GroupSelect
